import { Employee, ExtendedReferencedVendor, SystemRightEnum, UserApprover, UserRule, UserSettingsInterface, Vendor, VendorRule } from "@finway-group/shared/lib/models"
import { EmployeeAbsence } from "@finway-group/shared/lib/models/user/employeeAbsence.model"
import UserCompanyProfileInterface from "@finway-group/shared/lib/models/user/userCompanyProfileInterface"
import { isNotSet } from "@finway-group/shared/lib/utils/common"

export interface UserCreditor {
    id: string
    email: string
    workPhone?: string
    position: string
    team: string
    systemRights: Array<SystemRightEnum>
    approvals?: Array<UserApprover>
    img?: string
    settings: UserSettingsInterface
    passwordExpired?: boolean
    tfaValid?: boolean
    weavrData: any
    companyProfiles?: Array<UserCompanyProfileInterface>
    dateDeleted?: Date
    deleted?: boolean
    tenantId?: string
    rule?: Array<UserRule>
    firstName: string
    lastName: string
    location: string
    superior?: string
    bic?: string
    iban?: string
    activeCompanyProfile: UserCompanyProfileInterface
    absence?: EmployeeAbsence
    expensesSoFar: number
    name: string
    creditorNumber?: string
}

export const mapEmployeeToUserCreditor = (employee: Employee): UserCreditor => ({
    ...employee,
    name: employee.getFullName(),
    creditorNumber: employee?.activeCompanyProfile?.creditorNumber ? String(employee.activeCompanyProfile.creditorNumber) : undefined,
})

export interface DuplicateVendorInformationInterface {
    vendor: Vendor
    matchedAttributes: Array<keyof Vendor>
}

export const getAllMatchedAttributes = (duplicateVendors: Array<DuplicateVendorInformationInterface>) => [
    ...new Set(duplicateVendors.flatMap(({ matchedAttributes }) => matchedAttributes)),
]

/* Vendor rule object could have only _id defined therefore at least two values need to be defined */
export const isVendorRuleEmpty = (rule: VendorRule | undefined) => Object.values(rule || {}).filter(Boolean).length < 2

export const isVendorCostCenterEmpty = (rule: VendorRule | undefined) => isNotSet(rule?.costCenter)

export const getVendorLocationLabel = (expenseVendor: ExtendedReferencedVendor) => {
    let locationLabel = ""
    if (!expenseVendor?.city && !expenseVendor?.zip && !expenseVendor?.country) {
        locationLabel = "-"
    } else if (expenseVendor?.city && expenseVendor?.country) {
        locationLabel = `${expenseVendor.city} ${expenseVendor.zip ? `(${expenseVendor.zip}` : ""}, ${expenseVendor.country})`
    } else if (expenseVendor.country) {
        locationLabel = expenseVendor.country
    }

    return locationLabel
}
